import Traders from './index';
import PolicSettings from './list/policSettings';
import order from './list/order';
import orderDetail from './list/orderDetail';

export default {
    path: '/home/traders',
    component: Traders,
    children: [
        {path: '/home/traders/policSettings', component: PolicSettings},
        {path: '/home/traders/order', component: order},
        {path: '/home/traders/orderDetail', component: orderDetail}
    ]
}

